// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.area-preview{
    background: white;
    padding: 30px;
    border-radius: 10px;
    min-height: 500px;
}

.info-box {
    cursor: pointer;
  }`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/plantillas/plantillas.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;EACjB","sourcesContent":[".area-preview{\n    background: white;\n    padding: 30px;\n    border-radius: 10px;\n    min-height: 500px;\n}\n\n.info-box {\n    cursor: pointer;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
